(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['proposalMessage.tmpl'] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n	";
  options = {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 8, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 8, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n	";
  options = {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 16, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 16, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n	";
  options = {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 32, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 32, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n		<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n			<a name=\"ity\"></a>\n			<span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n			<div class=\"activity-item\">\n				<div class=\"fluid-container\">\n					<div class=\"col col8\">\n						<div class=\"action\">\n							<span class=\"user-avatar\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\"></span>\n							<div class=\"activity-description\">\n								<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n								posted an update\n							</div>\n						</div>\n						<div class=\"comment teacher-comment js-teacher-message\">\n							<p>\n							";
  stack2 = ((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.thankYouAssets)),stack1 == null || stack1 === false ? stack1 : stack1.interimThankYouLetterText)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							</p>\n						</div>\n					</div>\n				</div>\n			</div>\n		</li>\n	";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n	";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.thankYouAssets)),stack1 == null || stack1 === false ? stack1 : stack1.mediumPhotoNames), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n	";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n		<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n			<a name=\"photos\"></a>\n			<span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n			<div class=\"activity-item\">\n				<div class=\"fluid-container\">\n					<div class=\"col col8\">\n						<div class=\"action\">\n							<span class=\"user-avatar\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\"></span>\n							<div class=\"activity-description\">\n								<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n								shared photos\n							</div>\n						</div>\n						<div class=\"comment teacher-comment js-teacher-message\">\n							";
  stack2 = helpers.each.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.thankYouAssets)),stack1 == null || stack1 === false ? stack1 : stack1.mediumPhotoNames), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						</div>\n					</div>\n				</div>\n			</div>\n		</li>\n	";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n								<div class=\"impact-photo\" id=\"photoIndex"
    + escapeExpression(((stack1 = ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.index)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" style=\"background-image: url("
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + ")\">\n									<img src=\""
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "\" />\n								</div>\n							";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n		<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n			<a name=\"dty\"></a>\n			<span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n			<div class=\"activity-item\">\n				<div class=\"fluid-container\">\n					<div class=\"col col8\">\n						<div class=\"action\">\n							<span class=\"user-avatar\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\"></span>\n							<div class=\"activity-description\">\n								<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n								posted an update\n							</div>\n						</div>\n						<div class=\"comment teacher-comment js-teacher-message\">\n							<p>\n								";
  stack2 = ((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.thankYouAssets)),stack1 == null || stack1 === false ? stack1 : stack1.impactLetterText)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							</p>\n						</div>\n					</div>\n				</div>\n			</div>\n		</li>\n	";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n    <span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n    <div class=\"activity-item\">\n    	<div class=\"fluid-container\">\n    		<div class=\"col col8\">\n    			<div class=\"action\">\n					<span class=\"user-avatar\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\"></span>\n					<div class=\"activity-description\">\n						";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.isStudentLed), {hash:{},inverse:self.program(16, program16, data),fn:self.program(11, program11, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  options = {hash:{},inverse:self.program(20, program20, data),fn:self.program(18, program18, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 4096, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 4096, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n					</div>\n				</div>\n				";
  options = {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 4, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 4, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n    		</div>\n    	</div>\n	</div>\n</li>\n";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n							<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a> and ";
  if (stack2 = helpers.teacherPossessivePronoun) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.teacherPossessivePronoun); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "\n							";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.moreThanOneStudent), {hash:{},inverse:self.program(14, program14, data),fn:self.program(12, program12, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  return buffer;
  }
function program12(depth0,data) {
  
  
  return "\n								students\n							";
  }

function program14(depth0,data) {
  
  
  return "\n								student\n							";
  }

function program16(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "\n							<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n						";
  return buffer;
  }

function program18(depth0,data) {
  
  
  return "\n							submitted this project\n						";
  }

function program20(depth0,data) {
  
  
  return "\n							responded\n						";
  }

function program22(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n				<div class=\"comment teacher-comment js-teacher-message\">\n					"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n				</div>\n				";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n";
  options = {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), ">=", 128, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), ">=", 128, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n";
  return buffer;
  }
function program25(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n	\n	";
  options = {hash:{},inverse:self.program(28, program28, data),fn:self.program(26, program26, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 512, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 512, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n";
  return buffer;
  }
function program26(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n	<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n	    <span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n	    <div class=\"activity-item\">\n	        <div class=\"action\">\n	            <span class=\"user-avatar\" style=\"background-image:url(";
  if (stack2 = helpers.baseCacheURL) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.baseCacheURL); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "images/project/dc-activity-icon.png)\"></span>\n	            <div class=\"activity-description\">\n	                ";
  stack2 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n	            </div>\n	        </div>\n	    </div>\n	</li>\n	";
  return buffer;
  }

function program28(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n	<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n	    <span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n	    <div class=\"activity-item\">\n	        <div class=\"action\">\n	            <span class=\"user-avatar\" style=\"background-image:url(";
  if (stack2 = helpers.baseCacheURL) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.baseCacheURL); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "images/project/dc-activity-icon.png)\"></span>\n	            <div class=\"activity-description\">\n	                <strong>"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.firstName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</strong>, "
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.type)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ", ";
  stack2 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n	            </div>\n	        </div>\n	    </div>\n	</li>\n	";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n";
  options = {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, (depth0 && depth0.userId), "==", ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.id), options) : helperMissing.call(depth0, "compare", (depth0 && depth0.userId), "==", ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.id), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n";
  return buffer;
  }
function program31(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n	<a name=\"dty\"></a>\n	<span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n	<div class=\"activity-item\">\n		<div class=\"fluid-container\">\n			<div class=\"col col8\">\n				<div class=\"action\">\n					<span class=\"user-avatar\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\"></span>\n					<div class=\"activity-description\">\n						<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n					</div>\n				</div>\n				<div class=\"comment teacher-comment js-teacher-message\">\n					<span>\n						<span class=\"ty-heads-up\">\n							<em><b>Only visible to you.</b> For every donation you receive, you can write a personal note to the donor if you wish.\n							Otherwise, we'll send them this message of thanks.</em>\n						</span>\n						";
  stack2 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n					</span>\n				</div>\n			</div>\n		</div>\n	</div>\n</li>\n";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-original-author-salutation=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n	\n    <span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n    <div class=\"activity-item\">\n    		<div class=\"fluid-container\">\n    			<div class=\"col col8\">\n    				<div class=\"action\">\n						";
  options = {hash:{},data:data};
  stack2 = ((stack1 = helpers.userAvatar || (depth0 && depth0.userAvatar)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), "", options) : helperMissing.call(depth0, "userAvatar", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), "", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						<div class=\"activity-description\">\n						<p>\n						";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.anonymous), {hash:{},inverse:self.program(37, program37, data),fn:self.program(34, program34, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  options = {hash:{},inverse:self.noop,fn:self.program(42, program42, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 1, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 1, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  options = {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.numDonations), ">", 1, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.numDonations), ">", 1, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n						";
  stack2 = helpers.each.call(depth0, (depth0 && depth0.honorees), {hash:{},inverse:self.noop,fn:self.programWithDepth(46, program46, data, depth0),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n						";
  stack2 = helpers.each.call(depth0, (depth0 && depth0.inMemoryOfs), {hash:{},inverse:self.noop,fn:self.programWithDepth(56, program56, data, depth0),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n						";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.givingPage), {hash:{},inverse:self.noop,fn:self.program(59, program59, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.multipleGiftCodesToAcknowledge), {hash:{},inverse:self.noop,fn:self.program(63, program63, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  options = {hash:{},inverse:self.noop,fn:self.program(68, program68, data),data:data};
  stack2 = ((stack1 = helpers.showGiftCodeText || (depth0 && depth0.showGiftCodeText)),stack1 ? stack1.call(depth0, (depth0 && depth0.original), options) : helperMissing.call(depth0, "showGiftCodeText", (depth0 && depth0.original), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						</p>\n						</div>\n					</div>\n					";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.message), {hash:{},inverse:self.noop,fn:self.program(76, program76, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n    			</div>\n    			<div class=\"col col4\">\n					";
  options = {hash:{},inverse:self.noop,fn:self.program(81, program81, data),data:data};
  stack2 = ((stack1 = helpers.showGiftCodeSection || (depth0 && depth0.showGiftCodeSection)),stack1 ? stack1.call(depth0, (depth0 && depth0.original), options) : helperMissing.call(depth0, "showGiftCodeSection", (depth0 && depth0.original), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n    			</div>\n    		</div>\n\n		\n		";
  stack2 = helpers.each.call(depth0, (depth0 && depth0.promocodes), {hash:{},inverse:self.noop,fn:self.program(90, program90, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n		\n		";
  stack2 = helpers.each.call(depth0, (depth0 && depth0.autodonationmatches), {hash:{},inverse:self.noop,fn:self.program(97, program97, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n		";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.embed || (depth0 && depth0.embed)),stack1 ? stack1.call(depth0, "proposalMessageResponse.tmpl", options) : helperMissing.call(depth0, "embed", "proposalMessageResponse.tmpl", options)))
    + "\n    </div>\n\n</li>\n";
  return buffer;
  }
function program34(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n							<strong>A donor</strong>\n							";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.state), {hash:{},inverse:self.noop,fn:self.program(35, program35, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  return buffer;
  }
function program35(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n								from "
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.state)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n							";
  return buffer;
  }

function program37(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n							";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation), {hash:{},inverse:self.program(40, program40, data),fn:self.program(38, program38, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  return buffer;
  }
function program38(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "\n								<strong>"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</strong>\n								";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.locationAndDonorTeacherRelationship || (depth0 && depth0.locationAndDonorTeacherRelationship)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), true, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), options) : helperMissing.call(depth0, "locationAndDonorTeacherRelationship", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), true, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), options)))
    + "\n							";
  return buffer;
  }

function program40(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "\n								";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.locationAndDonorTeacherRelationship || (depth0 && depth0.locationAndDonorTeacherRelationship)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), false, (depth0 && depth0.undefined), options) : helperMissing.call(depth0, "locationAndDonorTeacherRelationship", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), false, (depth0 && depth0.undefined), options)))
    + "\n							";
  return buffer;
  }

function program42(depth0,data) {
  
  
  return "\n							gave\n						";
  }

function program44(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n							"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.numDonations)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " times\n						";
  return buffer;
  }

function program46(depth0,data,depth1) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n							";
  stack2 = helpers['if'].call(depth0, ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.first), {hash:{},inverse:self.noop,fn:self.program(47, program47, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							";
  options = {hash:{},inverse:self.noop,fn:self.program(49, program49, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth1 && depth1.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth1 && depth1.honorees)),stack1 == null || stack1 === false ? stack1 : stack1.length), ">", 1, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth1 && depth1.honorees)),stack1 == null || stack1 === false ? stack1 : stack1.length), ">", 1, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							"
    + escapeExpression(((stack1 = (depth0 && depth0.familiarDonorGreeting)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.city), {hash:{},inverse:self.noop,fn:self.program(52, program52, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  stack2 = helpers.unless.call(depth0, ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.last), {hash:{},inverse:self.noop,fn:self.program(54, program54, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  return buffer;
  }
function program47(depth0,data) {
  
  
  return "in honor of";
  }

function program49(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n								";
  stack2 = helpers['if'].call(depth0, ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.last), {hash:{},inverse:self.noop,fn:self.program(50, program50, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							";
  return buffer;
  }
function program50(depth0,data) {
  
  
  return "and";
  }

function program52(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " from "
    + escapeExpression(((stack1 = (depth0 && depth0.city)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ", "
    + escapeExpression(((stack1 = (depth0 && depth0.stateAbbreviated)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  return buffer;
  }

function program54(depth0,data) {
  
  
  return ", ";
  }

function program56(depth0,data,depth1) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n							";
  stack2 = helpers['if'].call(depth0, ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.first), {hash:{},inverse:self.noop,fn:self.program(57, program57, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							";
  options = {hash:{},inverse:self.noop,fn:self.program(49, program49, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth1 && depth1.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth1 && depth1.inMemoryOfs)),stack1 == null || stack1 === false ? stack1 : stack1.length), ">", 1, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth1 && depth1.inMemoryOfs)),stack1 == null || stack1 === false ? stack1 : stack1.length), ">", 1, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							"
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0));
  stack2 = helpers.unless.call(depth0, ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.last), {hash:{},inverse:self.noop,fn:self.program(54, program54, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  return buffer;
  }
function program57(depth0,data) {
  
  
  return "in memory of";
  }

function program59(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n							";
  options = {hash:{},inverse:self.noop,fn:self.program(60, program60, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.givingPage)),stack1 == null || stack1 === false ? stack1 : stack1.name), "!=", "", options) : helperMissing.call(depth0, "compare", ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.givingPage)),stack1 == null || stack1 === false ? stack1 : stack1.name), "!=", "", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  return buffer;
  }
function program60(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n								";
  options = {hash:{},inverse:self.noop,fn:self.program(61, program61, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.honoree), "||", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.inMemoryOf), options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.honoree), "||", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.inMemoryOf), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n								in support of <a href=\"";
  if (stack2 = helpers.baseURL) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.baseURL); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.givingPage)),stack1 == null || stack1 === false ? stack1 : stack1.challengeURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.givingPage)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n							";
  return buffer;
  }
function program61(depth0,data) {
  
  
  return " and ";
  }

function program63(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n							with ";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.givingHeavierCreditToGCPurchasers), {hash:{},inverse:self.program(66, program66, data),fn:self.program(64, program64, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += " from a few friends\n						";
  return buffer;
  }
function program64(depth0,data) {
  
  
  return "gift cards";
  }

function program66(depth0,data) {
  
  
  return "help";
  }

function program68(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n							with ";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.givingHeavierCreditToGCPurchasers), {hash:{},inverse:self.program(66, program66, data),fn:self.program(69, program69, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += " from ";
  options = {hash:{},inverse:self.program(73, program73, data),fn:self.program(71, program71, data),data:data};
  stack2 = ((stack1 = helpers.isGiftCodeAnonymous || (depth0 && depth0.isGiftCodeAnonymous)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode), options) : helperMissing.call(depth0, "isGiftCodeAnonymous", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						";
  return buffer;
  }
function program69(depth0,data) {
  
  
  return "a gift card";
  }

function program71(depth0,data) {
  
  
  return "an anonymous donor";
  }

function program73(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "<strong>";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.purchaserFamiliarDonorGreeting), {hash:{},inverse:self.noop,fn:self.program(74, program74, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "</strong>";
  return buffer;
  }
function program74(depth0,data) {
  
  var stack1;
  return escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.purchaserFamiliarDonorGreeting)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  }

function program76(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n						<div class=\"comment ";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.correspondsToGrantAccount), {hash:{},inverse:self.noop,fn:self.program(77, program77, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\">\n							";
  stack2 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.donorMessageLink), {hash:{},inverse:self.noop,fn:self.program(79, program79, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						</div>\n					";
  return buffer;
  }
function program77(depth0,data) {
  
  
  return "partner-comment";
  }

function program79(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n								<br/></br>\n								<a href=\"";
  stack2 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.donorMessageLink)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\" rel=\"nofollow\" target=\"_blank\">Learn more.</a>\n							";
  return buffer;
  }

function program81(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n						\n						<div class=\"partner-logo-wrapper\" ";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.sponsor), {hash:{},inverse:self.noop,fn:self.program(82, program82, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += ">\n							";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.correspondsToGrantAccount), {hash:{},inverse:self.program(86, program86, data),fn:self.program(84, program84, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						</div>\n					";
  return buffer;
  }
function program82(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "data-track='{\"type\": \"gift card logo\", \"sponsor\": { \"sponsor\" : \"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.removeNonAlphaNumericChars || (depth0 && depth0.removeNonAlphaNumericChars)),stack1 ? stack1.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.sponsor), options) : helperMissing.call(depth0, "removeNonAlphaNumericChars", ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.sponsor), options)))
    + "\", \"campaign\" : \"giftcode\" } }'";
  return buffer;
  }

function program84(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n								<span class=\"logo-holder\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n							";
  return buffer;
  }

function program86(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n								";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode), {hash:{},inverse:self.noop,fn:self.program(87, program87, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							";
  return buffer;
  }
function program87(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n									";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.purchaserGrantAccountLogo), {hash:{},inverse:self.noop,fn:self.program(88, program88, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n								";
  return buffer;
  }
function program88(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n										<div class=\"giftcard\">\n											<span class=\"logo-holder\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.purchaserGrantAccountLogo)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ");\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.giftCode)),stack1 == null || stack1 === false ? stack1 : stack1.purchaserFamiliarDonorGreeting)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n										</div>\n									";
  return buffer;
  }

function program90(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n\n			<div id=\"pm"
    + escapeExpression(((stack1 = (depth0 && depth0.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"fluid-container activity-response\">\n				<div class=\"col col8\">\n					<div class=\"action\">\n						";
  options = {hash:{},data:data};
  stack2 = ((stack1 = helpers.userAvatar || (depth0 && depth0.userAvatar)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), "partner", options) : helperMissing.call(depth0, "userAvatar", (depth0 && depth0.author), "partner", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						<div class=\"activity-description\">\n							<strong>"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</strong> matched this donation\n						</div>\n					</div>\n					";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.message), {hash:{},inverse:self.noop,fn:self.program(91, program91, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n				</div>\n				<div class=\"col col4\">\n					";
  options = {hash:{},inverse:self.noop,fn:self.program(94, program94, data),data:data};
  stack2 = ((stack1 = helpers.photoURLExistsAndIsNotPlaceholder || (depth0 && depth0.photoURLExistsAndIsNotPlaceholder)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL), options) : helperMissing.call(depth0, "photoURLExistsAndIsNotPlaceholder", ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n				</div>\n\n			</div>\n		";
  return buffer;
  }
function program91(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n						<div class=\"comment partner-comment\">\n							";
  stack2 = ((stack1 = (depth0 && depth0.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n							";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.donorMessageLink), {hash:{},inverse:self.noop,fn:self.program(92, program92, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						</div>\n					";
  return buffer;
  }
function program92(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n								<br/></br>\n								<a href=\"";
  stack2 = ((stack1 = (depth0 && depth0.donorMessageLink)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\" rel=\"nofollow\" target=\"_blank\">Learn more.</a>\n							";
  return buffer;
  }

function program94(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n						<div class=\"partner-logo-wrapper match-wrapper\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.sponsor), {hash:{},inverse:self.noop,fn:self.program(95, program95, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n							<span class=\"logo-holder\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n						</div>\n					";
  return buffer;
  }
function program95(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "data-track='{\"type\": \"promo code logo\", \"sponsor\": { \"sponsor\" : \"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.removeNonAlphaNumericChars || (depth0 && depth0.removeNonAlphaNumericChars)),stack1 ? stack1.call(depth0, (depth0 && depth0.sponsor), options) : helperMissing.call(depth0, "removeNonAlphaNumericChars", (depth0 && depth0.sponsor), options)))
    + "\", \"campaign\" : \"promocode\" } }'";
  return buffer;
  }

function program97(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n\n			<div id=\"pm"
    + escapeExpression(((stack1 = (depth0 && depth0.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"fluid-container activity-response\">\n				<div class=\"col col8\">\n					<div class=\"action\">\n						";
  options = {hash:{},data:data};
  stack2 = ((stack1 = helpers.userAvatar || (depth0 && depth0.userAvatar)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), "partner", options) : helperMissing.call(depth0, "userAvatar", (depth0 && depth0.author), "partner", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						<div class=\"activity-description\">\n							<strong>"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</strong> matched this donation\n						</div>\n					</div>\n					";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.message), {hash:{},inverse:self.noop,fn:self.program(91, program91, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n				</div>\n				<div class=\"col col4\">\n					";
  options = {hash:{},inverse:self.noop,fn:self.program(98, program98, data),data:data};
  stack2 = ((stack1 = helpers.photoURLExistsAndIsNotPlaceholder || (depth0 && depth0.photoURLExistsAndIsNotPlaceholder)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL), options) : helperMissing.call(depth0, "photoURLExistsAndIsNotPlaceholder", ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n				</div>\n			</div>\n		";
  return buffer;
  }
function program98(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n					<div class=\"partner-logo-wrapper match-wrapper\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.sponsor), {hash:{},inverse:self.noop,fn:self.program(99, program99, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n						<span class=\"logo-holder\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n					</div>\n					";
  return buffer;
  }
function program99(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "data-track='{\"type\": \"promo code logo\", \"sponsor\": { \"sponsor\" : \"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.removeNonAlphaNumericChars || (depth0 && depth0.removeNonAlphaNumericChars)),stack1 ? stack1.call(depth0, (depth0 && depth0.sponsor), options) : helperMissing.call(depth0, "removeNonAlphaNumericChars", (depth0 && depth0.sponsor), options)))
    + "\", \"campaign\" : \"autodonationmatch\" } }'";
  return buffer;
  }

function program101(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n	<li id=\"pm"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n		<span class=\"activity-timestamp\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.createDatePhrase)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n		<div class=\"activity-item\">\n			<div class=\"fluid-container\">\n				<div class=\"col col8\">\n					";
  stack2 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.digitalGratitude)),stack1 == null || stack1 === false ? stack1 : stack1.showLoginMessage), {hash:{},inverse:self.program(104, program104, data),fn:self.program(102, program102, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n				</div>\n			</div>\n		</div>\n	</li>\n";
  return buffer;
  }
function program102(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "\n						<div class=\"action\">\n							<span class=\"user-avatar\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\"></span>\n							<div class=\"activity-description\">\n								<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n								posted photos\n							</div>\n						</div>\n						<div class=\"dg-placeholder\"><svg class=\"icon icon-picture\"><use xlink:href=\"/images/icon/icon-junior.svg#icon-picture\"></use></svg></div>\n						<div class=\"log-in-cta\">If you gave to this project, you may <a href=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.digitalGratitude)),stack1 == null || stack1 === false ? stack1 : stack1.loginUrl)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">log in</a> to see photos.</div>\n					";
  return buffer;
  }

function program104(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n						<div class=\"action\">\n							<span class=\"user-avatar\" style=\"background-image:url("
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.photoURL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")\"></span>\n							<div class=\"activity-description\">\n								<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options) : helperMissing.call(depth0, "userPageURL", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n								posted photos\n								<p>(click to enlarge)</p>\n							</div>\n						</div>\n						<div class=\"image-gallery\">\n							";
  stack2 = helpers.each.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.digitalGratitude)),stack1 == null || stack1 === false ? stack1 : stack1.photoUrls), {hash:{},inverse:self.noop,fn:self.program(105, program105, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						</div>\n					";
  return buffer;
  }
function program105(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n								<a id=\"dgThumbnailPhoto"
    + escapeExpression(((stack1 = ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.index)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"dg-thumbnail\" style=\"background-image: url(";
  if (stack2 = helpers.thumbnailUrl) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.thumbnailUrl); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + ")\"></a>\n								<div id=\"dgMainPhoto"
    + escapeExpression(((stack1 = ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.index)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"dg-target\">\n									<div class='image-container' role='presentation'>\n										<img src=";
  if (stack2 = helpers.mainUrl) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.mainUrl); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + " alt=\""
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "'s classroom photo update\"/>\n										<a class='image-close'><svg class=\"icon icon-close\"><use xlink:href=\"/images/icon/icon-junior.svg#icon-close\"></use></svg></a>\n									</div>\n								</div>\n							";
  return buffer;
  }

  buffer += "\n";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.thankYouAssets), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n\n\n";
  options = {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data};
  stack2 = ((stack1 = helpers.showOneOffTeacherComment || (depth0 && depth0.showOneOffTeacherComment)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), options) : helperMissing.call(depth0, "showOneOffTeacherComment", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n\n";
  options = {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "<", 4096, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "<", 4096, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n\n\n";
  options = {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 8192, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 8192, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n\n";
  options = {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "<=", 2, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "<=", 2, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n\n\n";
  options = {hash:{},inverse:self.noop,fn:self.program(101, program101, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 16384, options) : helperMissing.call(depth0, "compare", ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.sourceId), "==", 16384, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n\n";
  return buffer;
  });
})();